import { initializeHybridly } from 'virtual:hybridly/config'
import { createHead } from '@unhead/vue'
import { autoAnimatePlugin as autoAnimate } from '@formkit/auto-animate/vue'
import i18n from './i18n'
import sentryPlugin from './sentry'
import './tailwind.css'

initializeHybridly({
	enhanceVue: (vue) => {
		const head = createHead()

		head.push({
			titleTemplate: (title) => title ? `${title} — Comprice.io` : 'Comprice.io',
		})

		vue.use(i18n)
		vue.use(head)
		vue.use(sentryPlugin)
		vue.use(autoAnimate)
	},
	progress: {
		color: 'var(--color-primary)',
	},
})
